import React from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {Input} from "reactstrap";
import ClientLogo from "./aside/ClientLogo";
import FinalizedEditionAlert from "./aside/FinalizedEditionAlert";
import AvailableNewsletters from "./aside/AvailableNewsletters";
import EditionCalendar from "./aside/EditionCalendar";
import ArticleList from "./aside/ArticleList";
import Search from "./aside/Search";
import {navBarToggle} from "../../../redux/actions/navigation";
import {getIsNavBarOpen} from "../../../redux/selectors/navigation";
import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks,
} from "body-scroll-lock";
import {isMobile} from "../../../util/screen";


class Navigation extends React.Component {
    constructor (props) {
        super(props);

        this.asideRef = React.createRef();
    }

    /**
     * react lifecycle
     */
    componentDidUpdate() {
        const targetAside = this.asideRef.current;

        if (isMobile() && this.props.isNavBarOpen) {
            disableBodyScroll(targetAside);
        } else {
            enableBodyScroll(targetAside);
        }
    }

    /**
     * react lifecycle
     */
    componentWillUnmount() {
        //clean up
        clearAllBodyScrollLocks();
    }

    /**
     * render content
     */
    render() {
        const navbarClass = this.props.isNavBarOpen ? "" : "d-none";

        return (
            <aside className={`${navbarClass} d-md-block min-vh-100 nest-aside`}>
                <div className="aside-inner py-3" ref={this.asideRef}>
                    <ClientLogo />

                    <FinalizedEditionAlert />

                    <AvailableNewsletters />

                    <EditionCalendar />

                    <Search />

                    <ArticleList />
                </div>
            </aside>
        )
    }
}

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapStateToProps = (state) => {
    return {
        isNavBarOpen : getIsNavBarOpen(state)
    };
};


/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapDispatchToProps = dispatch => {
    return {
        onNavBarToggled: () => {
            dispatch(navBarToggle())
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
